import Api from '@/utils/Api';

export const createClientBill = async (clientId, data) => {
  return await Api.post(`clients/${clientId}/bills`, data);
};

export const getClient = async (clientId) => {
  return await Api.get(`clients/${clientId}`);
};

export const createPersonnel = async (clientId, data) => {
  return await Api.post(`clients/${clientId}/personnel`, data);
};

export const updatePersonnel = async (clientId, personnelId, data) => {
  return await Api.put(`clients/${clientId}/personnel/${personnelId}`, data);
};

export const getPresignedUrl = async (id, personnelId, data) => {
  return await Api.post(`/clients/${id}/personnel/${personnelId}/presigned/upload`, data);
};

export const uploadPersonnelFiles = async (id, personnelId, data) => {
  return await Api.patch(`/clients/${id}/personnel/${personnelId}/files`, data);
};

export const presignedToDownloadingFile = async (clientId, personnelId, data) => {
  return await Api.post(`/clients/${clientId}/personnel/${personnelId}/presigned/download`, data);
};

export const changePersonnelStatus = async (clientId, personnelId, data) => {
  return await Api.patch(`/clients/${clientId}/personnel/${personnelId}/status`, data);
};

export const requestPersonnelDismissal = async (clientId, personnelId, data) => {
  return await Api.post(`/clients/${clientId}/personnel/${personnelId}/requests`, data);
};

export const getPersonnelFileUploadUrl = async (clientId, personnelId, requestId, data) => {
  return await Api.post(
    `/clients/${clientId}/personnel/${personnelId}/requests/${requestId}/presigned/upload`,
    data,
  );
};

export const uploadPersonnelFileRequest = async (clientId, personnelId, requestId, data) => {
  return await Api.patch(
    `/clients/${clientId}/personnel/${personnelId}/requests/${requestId}/files`,
    data,
  );
};
